var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9344 3.05747H7.56649C7.19135 3.05747 6.97067 2.95977 6.69483 2.71839L6.3583 2.42529C5.99419 2.1092 5.70732 2 5.16667 2H3.52265C2.5572 2 2 2.57471 2 3.73563V5.27011H14.6667V4.83333C14.6667 3.64943 14.0874 3.05747 12.9344 3.05747Z",
    fill: "#09090A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.33333C2.65333 7.33333 2.31789 7.38144 2 7.47135V6.05172H14.6667V10.8851C14.6667 12.069 14.0929 12.6667 13.0999 12.6667H6.26686C6.52248 12.1666 6.66667 11.6001 6.66667 11C6.66667 8.97496 5.02504 7.33333 3 7.33333Z",
    fill: "#09090A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11C6 12.6417 4.62992 14 3 14C1.35827 14 0 12.6535 0 11C0 9.35827 1.35827 8 3 8C4.64764 8 6 9.35827 6 11ZM2.61614 12.5886C2.61614 12.8071 2.79921 12.9488 3.00591 12.9488C3.20669 12.9488 3.38976 12.8071 3.38976 12.5886V11.3602H4.51772C4.7185 11.3602 4.87795 11.1949 4.87795 11C4.87795 10.8051 4.7185 10.6398 4.51772 10.6398H3.38976V9.41732C3.38976 9.19291 3.20669 9.05118 3.00591 9.05118C2.79921 9.05118 2.61614 9.19291 2.61614 9.41732V10.6398H1.48819C1.2874 10.6398 1.12205 10.8051 1.12205 11C1.12205 11.1949 1.2874 11.3602 1.48819 11.3602H2.61614V12.5886Z",
    fill: "#09090A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCategory);
export default __webpack_public_path__ + "static/media/icon-add-category.7c64eee687f1c058796d27bf4ed6cc57.svg";
export { ForwardRef as ReactComponent };